import { useEffect, useRef, useState, useCallback, forwardRef } from 'react';
import Input from 'input-format/react';
import { AsYouType, parsePhoneNumberCharacter } from 'libphonenumber-js/min';
import { Select } from 'modules/Select';
import { TextInput } from 'modules/TextInput';
import { Container, SelectContainer, InputContainer } from '../styled';
import { transformValue, getCountryFromPartialInputValue, getCountryFromPartialE164, useCountries, useControlledWarning, migrateNationalNumber, toE164, } from '../utils';
export const CountryAndInput = forwardRef((props, forwardedRef) => {
    const { id, value: controlledValue, defaultValue, defaultCountry = 'SE', countries: translations, disabled = false, invalid = false, onChange, describedBy, onBlur, required, name, } = props;
    const { current: controlled } = useRef(Boolean(controlledValue));
    useControlledWarning(controlled, controlledValue);
    const countries = useCountries(translations);
    const [country, setCountry] = useState(defaultCountry);
    const [outputValue, setOutputValue] = useState(controlledValue || defaultValue);
    const [inputValue, setInputValue] = useState(() => transformValue(outputValue));
    const format = useCallback((value) => {
        const asYouType = new AsYouType(country);
        const text = asYouType.input(value !== null && value !== void 0 ? value : '');
        const template = asYouType.getTemplate();
        return { text, template };
    }, [country]);
    const handleChange = useCallback((parsedValue) => {
        if (typeof parsedValue !== 'string') {
            return;
        }
        const nextCountry = getCountryFromPartialInputValue(country, parsedValue);
        const asYouType = new AsYouType(nextCountry);
        asYouType.input(parsedValue);
        const phoneNumber = asYouType.getNumber();
        setOutputValue((phoneNumber && phoneNumber.number) || '');
        setInputValue(parsedValue);
        setCountry(nextCountry);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onChange, country]);
    const handleSelect = useCallback((event) => {
        const nextCountry = event.target.value;
        const nextInputValue = migrateNationalNumber(nextCountry, inputValue);
        const nextOutputValue = toE164(nextCountry, nextInputValue);
        setCountry(nextCountry);
        setInputValue(nextInputValue);
        setOutputValue(nextOutputValue);
    }, [inputValue]);
    useEffect(() => {
        const updatedFromControlledValue = controlled && controlledValue !== outputValue;
        if (updatedFromControlledValue) {
            const nextCountry = getCountryFromPartialE164(country, controlledValue);
            const nextInputValue = transformValue(controlledValue);
            setInputValue(nextInputValue);
            setOutputValue(controlledValue);
            setCountry(nextCountry);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlledValue]);
    useEffect(() => {
        if (onChange) {
            onChange(outputValue || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outputValue]);
    return (<Container>
      <SelectContainer>
        <Select value={country} onChange={handleSelect} disabled={disabled} invalid={invalid} stretch>
          {countries.map(({ code, label }) => (<option key={code} value={code}>
              {label}
            </option>))}
        </Select>
      </SelectContainer>
      <InputContainer>
        <Input 
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error types are incorrect in "input-format/react", maybe consider a different library/solution?
    inputComponent={TextInput} format={format} parse={parsePhoneNumberCharacter} ref={forwardedRef} value={inputValue} onChange={handleChange} disabled={disabled} invalid={invalid} stretch aria-describedby={describedBy} onBlur={onBlur} required={required} name={name} id={id}/>
      </InputContainer>
    </Container>);
});
